import React from 'react'
import { useAuthContext } from './components/partials'
import Dashboard from './pages/Dashboard'

export const App: React.FC = () => {
  const { isAuthenticated } = useAuthContext()
  return <>{isAuthenticated && <Dashboard />}</>
}
export default App
